import {storeInstance} from '@aofl/store/dist/legacy';
import {routerInstance} from '@aofl/router';
import {deepAssign} from '@aofl/object-utils';

import {sdoNs, pages, permissions, userTypes, dynamicPages } from '@modules/constants-enumerate';
import {hasPermissionForRole} from '../permissions';
import {leftMenuLabels, siteHeaderLabels} from '../i18n-labels';
import {html} from 'lit-html';
import {until} from 'lit-html/directives/until';
import {productIcons} from '@modules/product-icon';

const getProductsForStudent = (products, visibilityByProduct) => {
  const returnHtml = [];
  products?.map((product) => {
    if (visibilityByProduct[product]) {
      returnHtml.push(html`<img src="${productIcons[product]}" class="mr-2" alt="${product}" width="18" height="18"/>`);
    }
  });
  return returnHtml;
};

const sdo = {
  namespace: sdoNs.LEFT_MENU,
  mutations: {
    /**
     *
     * @return {Object}
     */
    init() {
      return {
      };
    },
  },
  decorators: [
    (nextState) => { // $menuItems
      const state = storeInstance.getState();
      const nextLeftMenuState = nextState[sdoNs.LEFT_MENU];
      const nextSessionState = nextState[sdoNs.SESSION];
      if (typeof nextLeftMenuState.$menuItems === 'undefined' ||
        nextSessionState !== state[sdoNs.SESSION] ||
        nextState[sdoNs.INVENTORY_UPDATE_LOG].results !== state[sdoNs.INVENTORY_UPDATE_LOG].results ||
        nextState[sdoNs.PARENT_DASHBOARD].students !== state[sdoNs.PARENT_DASHBOARD].students
      ) {
        const userType = nextSessionState.type;
        const toRoute = routerInstance?.currentRoute?.matchedRoute?.path;
        const currentRole = nextSessionState.current_role;
        const lowerLevelAdminsPermissions = [
          permissions.ROSTER_FULL,
          permissions.ROSTER,
          permissions.EXPORT_ALL,
          permissions.ALL
        ];
        let $menuItems = [];
        if (nextSessionState.type === userTypes.PARENT) {
          const nextParentDashState = nextState[sdoNs.PARENT_DASHBOARD];
          nextParentDashState.students?.map((student) => {
            const productIcons = getProductsForStudent(student.products, nextParentDashState.dashboardIsVisible);
            if (productIcons.length > 0) {
              $menuItems.push({
                label: html`${student.first_name} ${productIcons}`,
                href: dynamicPages.parentDashboard(student.id),
                linkId: 'link-to-parent-student-dashboard',
                biId: 'link_to_parent_student_dashboard',
                show: true,
                trackUrlPartial: true,
              });
            }
          });
          $menuItems.push({
            label: until(leftMenuLabels.REDEEM_CODE),
            href: pages.PARENT_REDEEM_CODE,
            linkId: 'link-to-parent-redeem-code',
            biId: 'link_to_parent_redeem_code',
            show: true,
            trackUrlPartial: true,
          });
          $menuItems.push({
            label: until(leftMenuLabels.PRODUCT_LAUNCH),
            href: pages.PARENT_HOMEPAGE,
            linkId: 'link-to-parent-product-launch',
            biId: 'link_to_parent_product_launch',
            show: true,
            trackUrl: true,
          });
          $menuItems.push({
            label: until(leftMenuLabels.MANAGE_ACCOUNT_AND_NOTIFICATIONS),
            href: pages.PARENT_PROFILE,
            linkId: 'link-to-parent-product-launch',
            biId: 'link_to_parent_product_launch',
            show: true,
            trackUrlPartial: true,
          });
          $menuItems.push({
            label: until(siteHeaderLabels.LOG_OUT),
            href: pages.LOGOUT,
            linkId: 'link-to-parent-log-out',
            biId: 'link_to_parent_log_out',
            show: true,
            trackUrlPartial: true,
          });
        } else {
          $menuItems = [
            {
              label: until(leftMenuLabels.CLASSES),
              icon: 'ai ai-classes small',
              linkClass: 'ml-nested',
              href: pages.CLASSES_SEARCH,
              linkId: 'link-to-classes',
              biId: 'link_to_classes',
              trackUrlPartial: true,
              show: nextSessionState.group_info.level !== nextSessionState.$classLevel,
            },
            {
              label: until(leftMenuLabels.TEACHERS),
              icon: 'ai ai-teacher',
              linkClass: 'ml-nested',
              href: pages.TEACHER_SEARCH,
              linkId: 'link-to-teachers',
              biId: 'link-to-teachers',
              show: (
                hasPermissionForRole([permissions.SPONSOR], currentRole)
                || hasPermissionForRole([permissions.HIDE_STUDENT], currentRole)
                || hasPermissionForRole([permissions.TEACHER_EDIT], currentRole)
                || hasPermissionForRole([permissions.READ], currentRole)
              ),
              trackUrlPartial: true,
            },
            {
              label: until(leftMenuLabels.STUDENTS),
              icon: 'ai ai-student',
              linkClass: 'ml-nested',
              href: pages.STUDENT_SEARCH,
              linkId: 'link-to-students',
              biId: 'link_to_students',
              show: hasPermissionForRole([permissions.SPONSOR], currentRole)
                || hasPermissionForRole([permissions.HIDE_STUDENT], currentRole)
                || hasPermissionForRole([permissions.STUDENT_EDIT], currentRole)
                || hasPermissionForRole([permissions.READ], currentRole),
              trackUrlPartial: true,
            },
            {
              label: until(leftMenuLabels.ROSTERS),
              icon: 'ai ai-roster',
              href: pages.ROSTERS,
              linkId: 'link-to-rosters',
              biId: 'link_to_rosters',
              show: !nextSessionState.settings.hide_sections[userType]?.rosters &&
                !hasPermissionForRole([permissions.SPONSOR], currentRole) &&
                !hasPermissionForRole([permissions.HIDE_STUDENT], currentRole) &&
                hasPermissionForRole(lowerLevelAdminsPermissions, currentRole),
              trackUrlPartial: true,
            },
            {
              label: until(leftMenuLabels.LICENSES),
              icon: 'ai ai-license small',
              href: pages.LICENSES,
              linkId: 'link-to-licenses',
              biId: 'link_to_licenses',
              show: !nextSessionState.settings.hide_sections[userType]?.licenses &&
                !hasPermissionForRole([permissions.SPONSOR], currentRole) &&
                !hasPermissionForRole([permissions.HIDE_STUDENT], currentRole),
            },
            {
              label: until(leftMenuLabels.MANAGEMENT),
              icon: 'ai ai-License-Management small',
              linkClass: 'ml-nested',
              href: pages.LICENSES,
              linkId: 'link-to-manage-licenses',
              biId: 'link_to_manage_licenses',
              show: !nextSessionState.settings.hide_sections[userType]?.licenses &&
                !hasPermissionForRole([permissions.SPONSOR], currentRole) &&
                !hasPermissionForRole([permissions.HIDE_STUDENT], currentRole),
              trackUrlPartial: (toRoute + '/' !== pages.LICENSE_HISTORY),
              warning: nextSessionState.currentMinimumQuantity === '0',
            },
            {
              label: until(leftMenuLabels.HISTORY),
              icon: 'ai ai-License-History small',
              linkClass: 'ml-nested',
              href: pages.LICENSE_HISTORY,
              linkId: 'link-to-license-history',
              biId: 'link_to_license_history',
              show: (
                !nextSessionState.settings.hide_sections[userType]?.licenses
                &&
                !hasPermissionForRole([permissions.SPONSOR], currentRole)
                &&
                !hasPermissionForRole([permissions.HIDE_STUDENT], currentRole)
              ),
              trackUrlPartial: true,
            },
            {
              label: until(leftMenuLabels.RESOURCES),
              icon: 'ai ai-resources',
              href: pages.RESOURCES,
              linkId: 'link-to-resources',
              biId: 'link_to_resources',
              show: !nextSessionState.settings.hide_sections[userType]?.resources,
              trackUrlPartial: true,
            },
          ];
        }

        nextState = deepAssign(nextState, `${sdoNs.LEFT_MENU}`, {$menuItems});
      }
      return nextState;
    }
  ]
};

storeInstance.addState(sdo);
